// extracted by mini-css-extract-plugin
module.exports = {"moreFromBloomberg":"personalizedModule_moreFromBloomberg__sDBgW"};